export function initializeScrollToTop() {
  let lastPathname = window.location.pathname

  // pathname 변경을 감지하고 스크롤을 최상단으로 이동
  function handlePathnameChange() {
    const currentPathname = window.location.pathname

    if (currentPathname !== lastPathname) {
      lastPathname = currentPathname

      if (!window.location.hash) {
        try {
          window.scrollTo(0, 0)
        } catch (error) {
          console.warn('Failed to scroll to top:', error)
        }
      }
    }
  }

  // pathname 변경 감지를 위한 이벤트 리스너
  window.addEventListener('popstate', handlePathnameChange)

  // history.pushState/replaceState 후에도 동작하도록 오버라이드
  const originalPushState = window.history.pushState
  const originalReplaceState = window.history.replaceState

  window.history.pushState = function () {
    originalPushState.apply(this, arguments)
    handlePathnameChange()
  }

  window.history.replaceState = function () {
    originalReplaceState.apply(this, arguments)
    handlePathnameChange()
  }
}
